<style lang="scss">
.login-content-div {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    background: linear-gradient(-45deg, #eef2ff, #f0f9ff, #faf5ff, #f8fafc);
    background-size: 400% 400%;
    animation: bgGradientShift 15s ease infinite;
    position: relative;
    overflow: hidden;

    @media screen and (max-width: 768px) {
        padding: 0;
    }

    /* 网格点阵 */
    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-image:
            radial-gradient(circle, rgba(22, 119, 255, 0.08) 1px, transparent 1px);
        background-size: 32px 32px;
        opacity: 0.6;
        pointer-events: none;
        z-index: 0;
        animation: gridPulse 4s ease-in-out infinite;
    }

    /* 浮动彩色 blob 1 - 蓝色 */
    &::after {
        content: '';
        position: absolute;
        top: -15%;
        left: -8%;
        width: 480px;
        height: 480px;
        background: radial-gradient(circle, rgba(22, 119, 255, 0.22) 0%, rgba(22, 119, 255, 0.08) 40%, transparent 70%);
        border-radius: 50%;
        pointer-events: none;
        z-index: 0;
        animation: floatBlob1 18s ease-in-out infinite;
    }
}

/* 额外 blob 通过 <span> 放到 template 里 */
.blob {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
    filter: blur(2px);

    &.blob-2 {
        bottom: -18%;
        right: -10%;
        width: 420px;
        height: 420px;
        background: radial-gradient(circle, rgba(114, 46, 209, 0.18) 0%, rgba(114, 46, 209, 0.06) 40%, transparent 70%);
        animation: floatBlob2 22s ease-in-out infinite;
    }

    &.blob-3 {
        top: 40%;
        left: 55%;
        width: 300px;
        height: 300px;
        background: radial-gradient(circle, rgba(82, 196, 26, 0.12) 0%, transparent 70%);
        animation: floatBlob3 25s ease-in-out infinite;
    }
}

/* ===== Keyframes ===== */
@keyframes bgGradientShift {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}

@keyframes gridPulse {

    0%,
    100% {
        opacity: 0.4;
    }

    50% {
        opacity: 0.7;
    }
}

@keyframes floatBlob1 {

    0%,
    100% {
        transform: translate(0, 0) scale(1);
    }

    33% {
        transform: translate(60px, 40px) scale(1.08);
    }

    66% {
        transform: translate(-30px, 80px) scale(0.95);
    }
}

@keyframes floatBlob2 {

    0%,
    100% {
        transform: translate(0, 0) scale(1);
    }

    33% {
        transform: translate(-70px, -50px) scale(1.12);
    }

    66% {
        transform: translate(40px, -30px) scale(0.92);
    }
}

@keyframes floatBlob3 {

    0%,
    100% {
        transform: translate(0, 0) scale(1);
    }

    50% {
        transform: translate(-80px, -60px) scale(1.15);
    }
}

.content-div-out {
    position: relative;
    z-index: 1;
    display: flex;
    width: 100%;
    max-width: 960px;
    min-height: 520px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
    overflow: hidden;

    @media screen and (max-width: 768px) {
        max-width: 100%;
        flex-direction: column;
        min-height: auto;
        border-radius: 0;
        box-shadow: none;
    }
}

.content-div-left {
    flex: 1;
    background: linear-gradient(135deg, #1677ff 0%, #0958d9 100%);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 3rem 2.5rem;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: -60px;
        right: -60px;
        width: 200px;
        height: 200px;
        background: rgba(255, 255, 255, 0.08);
        border-radius: 50%;
    }

    &::after {
        content: '';
        position: absolute;
        bottom: -40px;
        left: -40px;
        width: 160px;
        height: 160px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 50%;
    }

    @media screen and (max-width: 768px) {
        padding: 2.5rem 1.5rem 2rem;
        min-height: auto;
        align-items: center;
        text-align: center;
    }
}

.brand-logo {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 2rem;

    .logo-circle {
        width: 44px;
        height: 44px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 32px;
            // height: 32px;
            border-radius: 6px;
        }

        span {
            font-size: 20px;
            font-weight: 700;
            color: #fff;
        }
    }

    .brand-name {
        color: #fff;
        font-size: 1.25rem;
        font-weight: 600;
        letter-spacing: 0.02em;
    }

    @media screen and (max-width: 768px) {
        flex-direction: column;
        gap: 8px;
        margin-bottom: 1rem;

        .logo-circle {
            width: 52px;
            height: 52px;
            border-radius: 14px;

            img {
                width: 38px;
                height: 38px;
            }
        }

        .brand-name {
            font-size: 1.1rem;
        }
    }
}

.content-left-text {
    position: relative;
    z-index: 1;
    color: #fff;

    .welcome-text {
        font-size: 1.75rem;
        font-weight: 700;
        margin-bottom: 0.75rem;
        letter-spacing: 0.02em;
        line-height: 1.3;
    }

    .welcome-sub {
        font-size: 0.95rem;
        opacity: 0.85;
        line-height: 1.6;
        margin-bottom: 2rem;
    }

    .feature-list {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .feature-item {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 0.9rem;
            font-weight: 500;
            color: #ffffff;
            background: rgba(255, 255, 255, 0.12);
            border: 1px solid rgba(255, 255, 255, 0.22);
            border-radius: 10px;
            padding: 10px 14px;
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            transition: all 0.25s ease;

            &:hover {
                background: rgba(255, 255, 255, 0.2);
                transform: translateX(4px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            }

            .feature-icon {
                width: 32px;
                height: 32px;
                border-radius: 8px;
                background: rgba(255, 255, 255, 0.22);
                border: 1px solid rgba(255, 255, 255, 0.35);
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
            }

            svg {
                width: 18px;
                height: 18px;
                stroke: #fff;
            }
        }
    }

    @media screen and (max-width: 768px) {
        .welcome-text {
            font-size: 1.35rem;
            margin-bottom: 0.4rem;
        }

        .welcome-sub {
            font-size: 0.85rem;
            margin-bottom: 0;
        }

        .feature-list {
            display: none;
        }
    }
}

.content-div-right {
    flex: 1;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 3rem 2.5rem;

    @media screen and (max-width: 768px) {
        padding: 2rem 1.5rem;
    }
}

.form-header {
    margin-bottom: 1.75rem;

    .form-title {
        font-size: 1.5rem;
        font-weight: 700;
        color: #1f2937;
        margin-bottom: 0.25rem;
    }

    .form-subtitle {
        font-size: 0.875rem;
        color: #6b7280;
    }

    @media screen and (max-width: 768px) {
        margin-bottom: 1.25rem;
        text-align: center;

        .form-title {
            font-size: 1.35rem;
        }

        .form-subtitle {
            font-size: 0.8rem;
        }
    }
}

.mode-switch {
    display: flex;
    background: #f3f4f6;
    border-radius: 8px;
    padding: 4px;
    margin-bottom: 1.5rem;

    .mode-btn {
        flex: 1;
        text-align: center;
        padding: 8px 12px;
        border-radius: 6px;
        font-size: 0.875rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        color: #6b7280;
        border: none;
        background: transparent;

        &.active {
            background: #fff;
            color: #1677ff;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        }

        &:hover:not(.active) {
            color: #374151;
        }
    }
}

.form-el-data {
    width: 100%;

    :deep(.ant-form-item-label > label) {
        font-weight: 500;
        color: #374151;
        font-size: 0.875rem;
    }

    :deep(.ant-input-affix-wrapper) {
        border-radius: 8px;
        padding: 4px 12px;
        height: 42px;
        border-color: #e5e7eb;
        transition: all 0.2s ease;

        &:hover {
            border-color: #d1d5db;
        }

        &.ant-input-affix-wrapper-focused {
            border-color: #1677ff;
            box-shadow: 0 0 0 3px rgba(22, 119, 255, 0.1);
        }
    }

    :deep(.ant-input) {
        border-radius: 8px;
        padding: 4px 12px;
        height: 42px;
        border-color: #e5e7eb;

        &:focus {
            border-color: #1677ff;
            box-shadow: 0 0 0 3px rgba(22, 119, 255, 0.1);
        }
    }

    :deep(.ant-input-prefix) {
        margin-right: 8px;
        color: #9ca3af;
    }
}

.code-row {
    display: flex;
    gap: 8px;
    width: 100%;

    .input-emailCode,
    .input-kaptchaCode {
        flex: 1;
        min-width: 0;
    }

    .send_emailCode {
        flex-shrink: 0;
        height: 42px;
        border-radius: 8px;
        font-weight: 500;
        padding: 0 16px;
    }

    .kaptchaImg {
        height: 42px;
        border-radius: 8px;
        cursor: pointer;
        border: 1px solid #e5e7eb;
        transition: all 0.2s ease;
        flex-shrink: 0;

        &:hover {
            opacity: 0.85;
        }
    }
}

.form-el-btn {
    margin-top: 1.5rem;

    .ant-btn {
        width: 100%;
        height: 42px;
        font-size: 0.9375rem;
        font-weight: 500;
        border-radius: 8px;
        background: #1677ff;
        border: none;
        transition: all 0.2s ease;

        &:hover {
            background: #0958d9;
        }

        &:active {
            background: #003eb3;
        }
    }
}

.bottom-div {
    margin-top: 1.25rem;
    text-align: center;

    a {
        color: #1677ff;
        text-decoration: none;
        font-size: 0.875rem;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            color: #0958d9;
            text-decoration: underline;
        }
    }
}
</style>

<template>
    <div class="login-content-div">
        <span class="blob blob-2"></span>
        <span class="blob blob-3"></span>
        <div class="content-div-out">
            <div class="content-div-left">
                <div class="brand-logo">
                    <div class="logo-circle">
                        <img src="/img/b6c8056d93148e81784120d630859504.png" alt="晓风">
                    </div>
                    <span class="brand-name">晓风授权站</span>
                </div>
                <div class="content-left-text">
                    <div class="welcome-text">欢迎回来 👋</div>
                    <div class="welcome-sub">晓风软件授权系统<br>安全、稳定、高效的软件授权管理平台</div>
                    <div class="feature-list">
                        <div class="feature-item">
                            <span class="feature-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="2.2" stroke="white" width="18" height="18">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
                                </svg>
                            </span>
                            安全可靠的授权验证
                        </div>
                        <div class="feature-item">
                            <span class="feature-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="2.2" stroke="white" width="18" height="18">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
                                </svg>
                            </span>
                            实时数据统计
                        </div>
                        <div class="feature-item">
                            <span class="feature-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="2.2" stroke="white" width="18" height="18">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                                </svg>
                            </span>
                            多用户协同管理
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-div-right">
                <div class="form-header">
                    <div class="form-title">账号登录</div>
                    <div class="form-subtitle">选择下方任一方式登录您的账号</div>
                </div>

                <div class="mode-switch">
                    <button class="mode-btn" :class="{ active: login_act == 1 }"
                        @click="bottom_btnClick('code')">邮箱验证码</button>
                    <button class="mode-btn" :class="{ active: login_act == 2 }"
                        @click="bottom_btnClick('pass')">账号密码</button>
                </div>

                <div class="form-div">
                    <a-form layout="vertical" ref="loginForm" class="form-el-data" :model="login" :rules="rules">
                        <a-form-item label="邮箱" name="email">
                            <a-input placeholder="请输入您的邮箱" v-model:value="login.email">
                                <template #prefix>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.8" stroke="currentColor" width="16" height="16">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                                    </svg>
                                </template>
                            </a-input>
                        </a-form-item>

                        <template v-if="login_act == 1">
                            <a-form-item label="邮箱验证码" name="code">
                                <div class="code-row">
                                    <a-input placeholder="6位数字验证码" v-model:value="login.code" class="input-emailCode">
                                        <template #prefix>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.8" stroke="currentColor" width="16" height="16">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                                            </svg>
                                        </template>
                                    </a-input>
                                    <a-button @click="getcodeClick()" class="send_emailCode" type="primary">{{
                                        login.getcode.text }}</a-button>
                                </div>
                            </a-form-item>
                        </template>

                        <template v-else>
                            <a-form-item label="密码" name="password">
                                <a-input type="password" placeholder="请输入您的密码" v-model:value="login.password">
                                    <template #prefix>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.8" stroke="currentColor" width="16" height="16">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                                        </svg>
                                    </template>
                                </a-input>
                            </a-form-item>
                            <a-form-item label="图形验证码" name="code">
                                <div class="code-row">
                                    <a-input placeholder="请输入验证码" v-model:value="login.code" class="input-kaptchaCode">
                                        <template #prefix>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.8" stroke="currentColor" width="16" height="16">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                                            </svg>
                                        </template>
                                    </a-input>
                                    <img class="kaptchaImg" ref="kaptchaImg" src="" @click="getKaptcha()" alt="验证码">
                                </div>
                            </a-form-item>
                        </template>
                    </a-form>

                    <a-form-item class="form-el-btn">
                        <a-button type="primary" v-if="login_act == 1" @click="submitForm" block>
                            邮箱验证码登录
                        </a-button>
                        <a-button type="primary" v-else @click="submitForm" block>
                            账号密码登录
                        </a-button>
                    </a-form-item>
                </div>

                <div class="bottom-div">
                    <a @click="bottom_btnClick('pass')" v-if="login_act == 1">使用账号密码登录 →</a>
                    <a @click="bottom_btnClick('code')" v-if="login_act == 2">使用邮箱验证码登录 →</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from 'vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { message } from 'ant-design-vue';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    setup() {
        var login = ref({
            email: "",
            password: "",
            code: "",
            getcode: {
                text: "发送"
            },
        });
        var kaptchaImgToken = ref('')
        var login_act = ref(1)
        const bottom_btnClick = (act) => {
            if (act === "pass") {
                login_act.value = 2
            }
            else {
                login_act.value = 1
            }
        }
        const checkNumber = (rule, value, callback) => {
            if (!value || !isNaN(Number(value))) {
                callback();
            } else {
                callback(new Error('请输入数字验证码'));
            }
        }
        const rules = ({
            email: [
                { required: true, message: '请输入邮箱', trigger: ['change'] },
                { type: 'email', message: '请输入正确的邮箱格式', trigger: ['change'] },
            ],
            code: [
                { required: true, message: '请输入验证码' },
                { min: 1, max: 6, message: '验证码长度错误', trigger: ['blur', 'change'] },
            ],
            password: [
                { required: true, message: '请输入密码', trigger: ['change'] },
                { min: 6, max: 20, message: '长度在6-20位', trigger: ['change'] },
            ],
        })

        const loginForm = ref(null);

        const debounce = (func, delay) => {
            let timeoutId;
            return (...args) => {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    func(...args);
                }, delay);
            };
        };
        const submitForm = debounce(() => {
            loginForm.value.validate().then(() => {
                openLoading()
                const data = new FormData()
                data.append("email", login.value.email)
                if (login_act.value == 1) {
                    data.append("act", "login_code")
                    data.append("code", login.value.code)
                }
                else {
                    data.append("act", "login_pass")
                    data.append("password", login.value.password)
                    data.append("code", login.value.code)
                    data.append("kaptchaImgToken", kaptchaImgToken.value)
                }
                axios.post(baseURL + "/userApi/login", data, { timeout: 5000 })
                    .then(res => {
                        fullscreenLoading.close()
                        if (res.data.code == 200) {
                            localStorage.setItem("token", res.data.token)
                            message.success(res.data.msg)
                            location.href = "/console"
                        }
                        else {
                            message.error(res.data.msg)
                            if (login_act.value != 1) {
                                getKaptcha()
                            }
                        }
                    })
                    .catch(err => {
                        fullscreenLoading.close()
                        console.log(err)
                        message.error('请求失败' + err.message)
                    })
            }).catch((err) => {
                message.error('请按照格式填写完整')
            })
        }, 1000);
        const getcodeClick = () => {
            loginForm.value.validateFields(['email']).then(() => {
                if (typeof login.value.getcode.text !== "string") {
                    message.error("请" + login.value.getcode.text + "秒后再试")
                    return
                }
                openLoading()
                const data = new FormData()
                data.append("email", login.value.email)
                data.append("password", login.value.password)
                data.append("act", "getcode")
                axios.post(baseURL + "/userApi/login", data, { timeout: 10000 })
                    .then(res => {
                        fullscreenLoading.close()
                        if (res.data.code == 200) {
                            login.value.getcode.text = 60;
                            let code_text_inter = setInterval(() => {
                                var code_text = login.value.getcode.text;
                                if (code_text !== 0) {
                                    login.value.getcode.text--;
                                }
                                else if (code_text === 0) {
                                    login.value.getcode.text = "发送";
                                    clearInterval(code_text_inter)
                                }
                            }, 1000);
                            message.success(res.data.msg)
                        }
                        else {
                            message.error(res.data.msg)
                        }
                    })
                    .catch(err => {
                        fullscreenLoading.close()
                        console.log(err)
                        message.error('请求失败' + err.message)
                    })
            }).catch((err) => {
                message.error('请按照格式填写完整邮箱')
            })
        }
        const isLogin = () => {
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.get(baseURL + "/userApi/isLogin", { timeout: 5000, headers: headers })
                .then(res => {
                    if (res.data.code == 200) {
                        message.success("您已经登录")
                        setTimeout(() => {
                            location.href = "/console"
                        }, 1000);
                    }
                })
                .catch(err => {
                    console.log(err)
                    message.error('请求失败：' + err.message)
                })
        }
        const kaptchaImg = ref(null)
        const getKaptcha = () => {
            axios.get(baseURL + "/userApi/getKaptcha")
                .then((res) => {
                    kaptchaImg.value.src = res.data.data
                    kaptchaImgToken.value = res.data.kaptchaImgToken
                })
        }
        watch(login_act, (newVal) => {
            if (newVal != 1) {
                getKaptcha()
            }
        })
        onMounted(isLogin)
        return {
            login,
            login_act,
            rules,
            loginForm,
            kaptchaImg,
            kaptchaImgToken,
            bottom_btnClick,
            submitForm,
            getcodeClick,
            checkNumber,
            getKaptcha
        };
    },

})
</script>
